import ComponentLayout from '~/src/layouts/component-layout';
import { Box, Text } from '@primer/react';
import { AccessibilityLink } from '~/src/components/accessibility-link';
import * as React from 'react';
export default {
  ComponentLayout,
  Box,
  Text,
  AccessibilityLink,
  React
};